// Card de metrica simple. Valor grande + label + detalle opcional.

import type { ReactNode } from 'react';

interface MetricCardProps {
  label: string;
  value: string | number;
  detail?: ReactNode;
  emphasis?: 'default' | 'success' | 'warning' | 'error';
  /**
   * Tarjeta principal de su fila: ocupa todo el alto de la celda y agranda el
   * numero. Para la que comparte fila con una columna de tarjetas apiladas y
   * quedaria corta al lado.
   *
   * El contenido NO se centra en vertical: asi el rotulo queda a la misma
   * altura que el de las tarjetas vecinas. Centrarlo deja los rotulos de la
   * fila desalineados y se lee como un descuido.
   *
   * Es una opcion del componente y no clases sueltas en el call-site a
   * proposito: el aspecto de una tarjeta sale de un solo lugar.
   */
  hero?: boolean;
}

const EMPHASIS_CLS: Record<NonNullable<MetricCardProps['emphasis']>, string> = {
  default: 'text-ink dark:text-ink-inverted',
  success: 'text-status-success',
  warning: 'text-status-warning',
  error: 'text-status-error',
};

export default function MetricCard({
  label,
  value,
  detail,
  emphasis = 'default',
  hero = false,
}: MetricCardProps): JSX.Element {
  return (
    <section
      className={`bg-surface dark:bg-surface-dark rounded-xl border border-surface-border dark:border-surface-dark-border p-5 space-y-2${
        hero ? ' h-full' : ''
      }`}
    >
      <p className="text-xs uppercase tracking-wider text-ink-muted font-medium">{label}</p>
      <p
        className={`${hero ? 'text-5xl' : 'text-3xl'} font-semibold tabular-nums ${EMPHASIS_CLS[emphasis]}`}
      >
        {value}
      </p>
      {detail ? <div className="text-xs text-ink-muted">{detail}</div> : null}
    </section>
  );
}
